import * as React from "react";
import {
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  Box,
  PopperPlacementType,
  IconButton,
  Tooltip,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

interface Props {
  id: string;
  popperPosition: PopperPlacementType;
  icon: React.ReactNode;
  toolTipText: string;
  children: React.ReactNode;
  close?: boolean;
}

const useStyle = makeStyles(theme => ({
  icon: {
    "padding": ".25rem",
    "float": "right",
    "& svg": {
      color: theme.palette.primary.main,
    },
  },
  overLap: {
    zIndex: 1,
  },
  border: {
    border: `solid 1px ${theme.palette.primary.light}`,
    borderRadius: 5,
  },
}));
export default function MoreOptionsMenu({
  id,
  popperPosition,
  toolTipText,
  children,
  icon,
  close,
}: Props) {
  const classes = useStyle();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen(!open);
  };
  React.useEffect(() => {
    if (close) {
      setOpen(false);
    }
  }, [close]);

  return (
    <>
      <Tooltip title={toolTipText} placement="top">
        <IconButton
          id={`menu-popup-button-${id}`}
          className={clsx(classes.icon, "more-options")}
          onClick={handleToggle}
          ref={anchorRef}
          aria-controls={open ? id : undefined}
          aria-haspopup="true"
          size="large"
        >
          {icon}
        </IconButton>
      </Tooltip>
      <Popper
        id="menu-popup-content"
        open={open}
        anchorEl={anchorRef.current}
        placement={popperPosition}
        transition
        disablePortal
        className={classes.overLap}
      >
        {({ TransitionProps }) =>
          open ? (
            <Grow {...TransitionProps}>
              <Paper className={classes.border}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <Box id={id}>{children}</Box>
                </ClickAwayListener>
              </Paper>
            </Grow>
          ) : (
            undefined
          )
        }
      </Popper>
    </>
  );
}
